import { useEffect, useState } from 'react';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle
} from '@/components/ui/alert-dialog';

import { setDisconnectConfirmListener, type PendingDisconnectConfirm } from './disconnect-confirm.store';

/** Renders the confirmation dialog for `confirmDisconnect`; mount once at the sheet root. */
export function DisconnectConfirmHost() {
	const [pending, setPending] = useState<PendingDisconnectConfirm | null>(null);

	useEffect(() => {
		setDisconnectConfirmListener(setPending);
		return () => setDisconnectConfirmListener(null);
	}, []);

	const settle = (confirmed: boolean) => {
		pending?.resolve(confirmed);
		setPending(null);
	};

	return (
		<AlertDialog open={pending !== null} onOpenChange={(open) => !open && settle(false)}>
			<AlertDialogContent className='max-w-[420px] gap-0 rounded-xl p-5 sm:max-w-[420px]'>
				<AlertDialogHeader className='gap-0'>
					<AlertDialogTitle className='text-sm'>Disconnect {pending?.platform ?? 'this integration'}?</AlertDialogTitle>
					<AlertDialogDescription className='mt-1 text-xs leading-[18px]'>
						Kim will stop syncing with {pending?.platform ?? 'this integration'} and remove the credentials and
						webhooks it set up. Nothing is deleted on the other side, but reconnecting means going through
						the connection flow again.
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className='mt-[18px]'>
					<AlertDialogCancel onClick={() => settle(false)}>Cancel</AlertDialogCancel>
					<AlertDialogAction
						className='border border-destructive bg-white text-destructive hover:bg-red-50'
						onClick={() => settle(true)}
					>
						Disconnect {pending?.platform ?? ''}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
